import React from 'react';
import { motion } from 'framer-motion';
import { Users, Building2, Handshake } from 'lucide-react';
export function HowItWorks() {
  return <section className="py-24 bg-dark relative overflow-hidden" data-id="element-132">
      <div className="container mx-auto px-6" data-id="element-133">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-134">
          <h2 className="font-rajdhani text-4xl md:text-5xl font-bold mb-6" data-id="element-135">
            THE PATH TO{' '}
            <span className="text-neon-lime text-glow-lime" data-id="element-136">VICTORY</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-137">
            How Pixelkeep connects the ecosystem from sign-up to signed
            contract.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-138">
          {/* Central Line for Desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-white/20 to-transparent -translate-x-1/2" data-id="element-139" />

          <div className="grid md:grid-cols-[1fr_auto_1fr] gap-8 items-center" data-id="element-140">
            {/* Left Side: Teams */}
            <div className="flex flex-col gap-8" data-id="element-141">
              <div className="flex items-center gap-4 justify-end text-right" data-id="element-142">
                <div data-id="element-143">
                  <h4 className="font-rajdhani text-xl font-bold text-neon-cyan" data-id="element-144">
                    Team Registration
                  </h4>
                  <p className="text-sm text-gray-400" data-id="element-145">
                    Create profile & connect socials
                  </p>
                </div>
                <div className="w-12 h-12 rounded-full bg-dark-card border border-neon-cyan/50 flex items-center justify-center shrink-0" data-id="element-146">
                  <Users className="w-5 h-5 text-neon-cyan" data-id="element-147" />
                </div>
              </div>
              <div className="flex items-center gap-4 justify-end text-right" data-id="element-148">
                <div data-id="element-149">
                  <h4 className="font-rajdhani text-xl font-bold text-neon-cyan" data-id="element-150">
                    Verification
                  </h4>
                  <p className="text-sm text-gray-400" data-id="element-151">
                    API validates audience metrics
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full bg-dark-card border border-white/10 flex items-center justify-center shrink-0" data-id="element-152">
                  <span className="font-rajdhani font-bold text-gray-500" data-id="element-153">
                    2
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-4 justify-end text-right" data-id="element-154">
                <div data-id="element-155">
                  <h4 className="font-rajdhani text-xl font-bold text-neon-cyan" data-id="element-156">
                    Set Inventory
                  </h4>
                  <p className="text-sm text-gray-400" data-id="element-157">
                    List available jersey spots
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full bg-dark-card border border-white/10 flex items-center justify-center shrink-0" data-id="element-158">
                  <span className="font-rajdhani font-bold text-gray-500" data-id="element-159">
                    3
                  </span>
                </div>
              </div>
            </div>

            {/* Center: The Match */}
            <div className="flex flex-col items-center justify-center py-8 md:py-0 relative z-10" data-id="element-160">
              <motion.div initial={{
              scale: 0.8,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} className="w-24 h-24 rounded-full bg-dark border-2 border-neon-lime flex items-center justify-center shadow-[0_0_30px_rgba(57,255,20,0.3)] relative" data-id="element-161">
                <Handshake className="w-10 h-10 text-neon-lime" data-id="element-162" />
                <div className="absolute inset-0 rounded-full border border-neon-lime animate-ping opacity-20" data-id="element-163" />
              </motion.div>
              <div className="mt-4 font-rajdhani font-bold text-xl tracking-widest text-white" data-id="element-164">
                DEAL SIGNED
              </div>
            </div>

            {/* Right Side: Brands */}
            <div className="flex flex-col gap-8" data-id="element-165">
              <div className="flex items-center gap-4" data-id="element-166">
                <div className="w-12 h-12 rounded-full bg-dark-card border border-neon-magenta/50 flex items-center justify-center shrink-0" data-id="element-167">
                  <Building2 className="w-5 h-5 text-neon-magenta" data-id="element-168" />
                </div>
                <div data-id="element-169">
                  <h4 className="font-rajdhani text-xl font-bold text-neon-magenta" data-id="element-170">
                    Brand Onboarding
                  </h4>
                  <p className="text-sm text-gray-400" data-id="element-171">Define campaign goals</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-172">
                <div className="w-10 h-10 rounded-full bg-dark-card border border-white/10 flex items-center justify-center shrink-0" data-id="element-173">
                  <span className="font-rajdhani font-bold text-gray-500" data-id="element-174">
                    2
                  </span>
                </div>
                <div data-id="element-175">
                  <h4 className="font-rajdhani text-xl font-bold text-neon-magenta" data-id="element-176">
                    Set Budget
                  </h4>
                  <p className="text-sm text-gray-400" data-id="element-177">Allocate EUR budget</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-178">
                <div className="w-10 h-10 rounded-full bg-dark-card border border-white/10 flex items-center justify-center shrink-0" data-id="element-179">
                  <span className="font-rajdhani font-bold text-gray-500" data-id="element-180">
                    3
                  </span>
                </div>
                <div data-id="element-181">
                  <h4 className="font-rajdhani text-xl font-bold text-neon-magenta" data-id="element-182">
                    Target Audience
                  </h4>
                  <p className="text-sm text-gray-400" data-id="element-183">
                    Select game titles & regions
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}